import ProfessionalDevelopment from '@/components/common/ProfessionalDevelopment/ProfessionalDevelopment';

export default ProfessionalDevelopment;
